import jwtDecode from 'jwt-decode'
import { shallowEqual } from 'react-redux'

import { State } from 'store/state'

import { useAppSelector } from '../store/hooks'

export enum PermissionsEnum {
  MANAGE_ACCOUNTS = 'manage:accounts',
  READ_ACCOUNT = 'read:account',
  UPDATE_ACCOUNT = 'update:account',
  CREATE_ACCOUNT = 'create:account',
  READ_SURVEYWINDOW = 'read:surveywindow',
  CREATE_SURVEYWINDOW = 'create:surveywindow',
  READ_ASSESSMENT = `read:assessment`,
  SAVE_ASSESSMENT = `save:assessment`,
  READ_REPORTS = 'read:reports',
}

export const useAuthPermissions = () => {
  const { token } = useAppSelector(
    (state: State) => ({
      token: state.authReducer.jwt,
    }),
    shallowEqual
  )

  if (token) {
    const decodedToken: { permissions: PermissionsEnum[] } = jwtDecode(token)
    return { permissions: decodedToken.permissions }
  }

  return { permissions: [] }
}
